import i18n from '../../locals/i18n';
import { FoodType } from '../../models';
import { AppState } from '../rootReducer';

export const isLoading = (state: AppState) => state.foodTypes.isLoading;
export const getFoodTypes = (state: AppState): FoodType[] => state.foodTypes.all;
export const getFoodTypeWithMinHoldingTime = (state: AppState): FoodType => state.foodTypes.foodTypeWithMinHoldingTime;
export const isAddEditLoading = (state: AppState) => state.foodTypes.isAddEditLoading;
export const isDeleteLoading = (state: AppState) => state.foodTypes.isDeleteLoading;
export const getTotal = (state: AppState) => state.foodTypes.total;

export const getFoodTypeName = (foodType?: FoodType): string => {
  return foodType?.translatedLabels?.find(({ languageCode }) => languageCode === i18n.language)?.translation;
};
